var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.alertText)?_c('div',{staticClass:"alert alert-warning-light d-flex",attrs:{"role":"alert"}},[_c('img',{attrs:{"src":"/themes/custom/ef2_custom/images/icons/info.svg","alt":"Warning icon"}}),_vm._v("\n    "+_vm._s(_vm.alertText)+"\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }